var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AssessmentGroup } from "../../shared/models/assessment-group";
var AssessmentGroupDisplay = /** @class */ (function (_super) {
    __extends(AssessmentGroupDisplay, _super);
    function AssessmentGroupDisplay() {
        var _this = _super.call(this) || this;
        _this.ShowAdd = false;
        _this.Show = false;
        return _this;
    }
    return AssessmentGroupDisplay;
}(AssessmentGroup));
export { AssessmentGroupDisplay };



// WEBPACK FOOTER //
// ./src/app/shared/models/assessment-group-display.ts.pre-build-optimizer.js